import { IgTypography } from "@intelligems/ig-theme";
import { ExperienceListDto, GenericExperienceFe } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { IgAlertSimple } from "@src/components/Utils/IgAlertSimple";
import { modLabelKey } from "@src/features/sharedExperience/components/rollouts/utils";

interface PriceRolloutWarningProps {
  experience: GenericExperienceFe;
}

export const PriceRolloutWarning = ({
  experience,
}: PriceRolloutWarningProps) => {
  const testErrorsMessage =
    experience.testTypes.hasTestOnsiteInjections &&
    experience.testTypes.hasTestContentOnsite
      ? modLabelKey["hasTestOnsiteInjections"] +
        " and " +
        modLabelKey["hasTestContentOnsite"]
      : experience.testTypes.hasTestOnsiteInjections
        ? modLabelKey["hasTestOnsiteInjections"]
        : experience.testTypes.hasTestContentOnsite &&
          modLabelKey["hasTestContentOnsite"];

  return (
    <IgAlertSimple
      severity={"warning"}
      message={
        <Grid item container direction={"row"} textAlign={"start"}>
          <IgTypography>
            Your test involved additional {testErrorsMessage}
            .
            <br />
            If you'd like to roll these out, you will need to manually implement
            these in Shopify.
          </IgTypography>
        </Grid>
      }
      alertKey={"price-updater-dialog"}
    />
  );
};
